import axios from 'axios'
import apiURI from './Api';

export default class TypeService {
  async getType(token) {
    const response = await axios({ method: 'get', url: `${apiURI}/product/category/getalltypes`, headers: { 'Authorization': 'Bearer ' + token } });
    return response.data;
  }

  async postRegisterType(token, descriptionEnglish, descriptionItalian, descriptionPortugues, descriptionSpanish) {
    
    const bodyJson = {
      descriptionEnglish,
      descriptionItalian,
      descriptionPortugues,
      descriptionSpanish,
   
    }
  
    const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/type/register`,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

  async postEditType(token, descriptionEnglish, descriptionItalian, descriptionPortugues, descriptionSpanish, idtype) {

    const bodyJson = {
      descriptionEnglish,
      descriptionItalian,
      descriptionPortugues,
      descriptionSpanish,
      idtype,
    }

    const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/type/edit`,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }
  
}
